const APP_SCROLL_CONTAINER_ATTRIBUTE = 'data-app-scroll-container';

export const APP_SCROLL_CONTAINER_SELECTOR = `[${APP_SCROLL_CONTAINER_ATTRIBUTE}]`;
export const appScrollContainerProps = { [APP_SCROLL_CONTAINER_ATTRIBUTE]: '' } as const;
